import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem
      primaryText='Edit'
      key='edit'
      value={`/ecommerce/orders/${resource.order_id}/discounts/${resource.id}/edit`}
    />
  ]
}

export default buildMenuItems
